import { injectIntl } from "react-intl"


export const ARM = 1
export const LEG = 2
export const ORAL = 3



export const VACCINATION_LOCATION = {
    [ARM]:  "VACCINATION.INPUT.SPOT.ARM",
    [LEG]:  "VACCINATION.INPUT.SPOT.LEG",
    [ORAL]: "VACCINATION.INPUT.SPOT.ORAL",
}
  
export const vaccineLocationUIHelper = (intl) => 
  Object.keys(VACCINATION_LOCATION).map((value) => ({
    value : value,
    label: intl.formatMessage({ id: VACCINATION_LOCATION[value] }),
  
}))


